module.exports = __webpack_public_path__ + "img/mouse-face.49e1c391.png";